var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, DateField, Grid, GridColumn, Heading, List, ListItem, Modal, ModalFooter, Notice, Text, Toggle, Tooltip, TooltipToggle } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { Spinner } from '../../config/common';
import { DEFAULT_VALID_UNTIL } from '../../stores/MandateStore';
import SpinnerToggle from '../../util/SpinnerToggle';
import { injectStores } from '../../util/StoresUtil';
let RepresentationRightsEditMandateModal = class RepresentationRightsEditMandateModal extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "editMandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { translate } = this.translateStore;
        const { mandateSaveError } = this.editMandateStore;
        const { isOpen, onClose } = this.props;
        return (React.createElement(Modal, { size: "6-col", isOpen: isOpen, onClose: onClose },
            React.createElement(SpinnerToggle, { name: Spinner.EDIT_MANDATE_MODAL }),
            React.createElement(Text, null,
                React.createElement(Heading, { className: "h3" }, translate('personPowers.editMandateModal.title')),
                mandateSaveError && this.renderMandateSaveErrorNotice(),
                React.createElement(Heading, { level: 2, className: "h4 text-bold text__margin-double" }, translate('personPowers.editMandateModal.mandateData')),
                React.createElement(List, { type: "unstyled", bordered: true }, this.renderMandateTypeToggleOptions()),
                this.renderValidUntil()),
            React.createElement(ModalFooter, null, this.renderFooter())));
    }
    renderValidUntil() {
        const { translate } = this.translateStore;
        const { validUntil, changeVisibleMandatesValidUntils, isValidUntilDisabled } = this.editMandateStore;
        return (React.createElement(Grid, { className: "text__margin-double" },
            React.createElement(GridColumn, { width: ['sm-5', 'lg-6'] },
                React.createElement(DateField, { label: translate('personPowers.editMandateModal.validUntil'), id: "valid-until", value: validUntil, datepicker: {
                        clearButtonLabel: translate('personPowers.editMandateModal.datepicker.clear'),
                        submitButtonLabel: translate('personPowers.editMandateModal.datepicker.submit'),
                        range: { from: new Date(), to: DEFAULT_VALID_UNTIL },
                        onSubmit: changeVisibleMandatesValidUntils,
                        onClear: changeVisibleMandatesValidUntils
                    }, onChange: changeVisibleMandatesValidUntils, helpMessage: translate('personPowers.editMandateModal.validUntil.notice'), errorMessage: !validUntil ? translate('personPowers.editMandateModal.validUntil.mandatory') : undefined, isDisabled: isValidUntilDisabled }))));
    }
    renderFooter() {
        const { translate } = this.translateStore;
        const { canEditCustomerMandate, isFormChanged } = this.editMandateStore;
        return (React.createElement(Grid, { align: ['between-xs', 'middle-xs'] },
            React.createElement(GridColumn, { width: ['xs'] },
                React.createElement(Button, { iconLeft: "#file-check-simple", disabled: !canEditCustomerMandate || !isFormChanged, text: translate('personPowers.editMandateModal.save'), onClick: this.editMandateStore.submitCustomerMandate })),
            React.createElement(GridColumn, { width: ['xs'] },
                React.createElement(Button, { text: translate('personPowers.editMandateModal.cancel'), link: true, onClick: () => this.editMandateStore.closeManageModal(this.editMandateStore.originalCustomerMandate) }))));
    }
    renderMandateSaveErrorNotice() {
        return (React.createElement(Notice, { type: "error", align: "center" }, this.translateStore.translate('personPowers.editMandateModal.mandateSaveError')));
    }
    renderMandateTypeToggleOptions() {
        const { translate } = this.translateStore;
        const { toggleMandateType, getMandateTypes, hasMandateType } = this.editMandateStore;
        return getMandateTypes().map((mandateType, index) => (React.createElement(ListItem, { key: index },
            React.createElement(Toggle, { id: `mandate-type-${mandateType}`, label: translate(`personPowers.mandate.type.${mandateType}`), onChange: () => toggleMandateType(mandateType), checked: hasMandateType(mandateType), children: React.createElement(Tooltip, { referenceElement: React.createElement(TooltipToggle, { id: `edit-mandate-modal-${mandateType}` }, translate(`personPowers.mandate.type.${mandateType}`)) }, translate(`personPowers.mandate.type.${mandateType}-tooltip`)) }))));
    }
};
RepresentationRightsEditMandateModal = __decorate([
    injectStores,
    observer
], RepresentationRightsEditMandateModal);
export default RepresentationRightsEditMandateModal;
